import { useMsal } from '@azure/msal-react';
import { getAuthConfig } from '@Utils/getApiUrl';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import { authSliceActions } from '@Store/slices/authSlice';
import { useGetUserInfoMutation } from '@Store/api/userApiSlice';
import { userInfoActions } from '@Store/slices/userInfoSlice';
import { useNavigate } from 'react-router-dom';

import BaseRoutePath from '@Router/baseRoutePathes.enum';
import { useAppDispatch } from '.';

interface ReturnValue {
  assignUserWithToken: (isLoginPage?: boolean) => Promise<void>;
}

const useAuthUserWithToken = (): ReturnValue => {
  const [getUser] = useGetUserInfoMutation();
  const { azureScopes } = getAuthConfig();
  const { instance } = useMsal();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const setUserData = (empNumber: string): void => {
    getUser({ empNo: empNumber })
      .unwrap()
      .then((userResp) => {
        dispatch(userInfoActions.setUser(userResp));
      });
  };

  const assignUserWithToken = async (isLoginPage = false): Promise<void> => {
    try {
      const tokenResponse = await instance.acquireTokenSilent({
        scopes: azureScopes,
        account: instance.getAllAccounts()[0],
      });

      const decoded = jwtDecode<JwtPayload & { employeeid: string }>(
        tokenResponse.accessToken
      );

      if (!decoded?.employeeid) {
        navigate(BaseRoutePath.NO_ACCESS);
      }

      dispatch(authSliceActions.setAuthToken(tokenResponse.accessToken));

      const sessionTokenJSONKey = `${tokenResponse.account.homeAccountId}-${tokenResponse.account.environment}-accesstoken-${tokenResponse.account.idTokenClaims?.aud}-${tokenResponse.tenantId}-${tokenResponse.scopes.join(' ')}--`;

      dispatch(authSliceActions.setJSONKey(sessionTokenJSONKey));

      setUserData(decoded.employeeid);

      if (isLoginPage) {
        navigate('/');
      }
    } catch (error) {
      console.error(error);
      navigate('/login');
    }
  };

  return { assignUserWithToken };
};

export default useAuthUserWithToken;
